import Checkbox from '@mui/material/Checkbox'
import { useContext, useState } from 'react'
import PrimaryButton from '../../../../../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../../../../../global/components/buttons/secondary-button/SecondaryButton'
import styles from '../styles/styles.module.css'
import { useParams } from 'react-router-dom'
import { fetchData } from '../../../../../../../global/utils/fetch'
import { removeTireRackOrderFromOrder } from './api'
import { WoDetailContext } from '../../../../../context/context'
import { ToastNotificationContext } from '../../../../../../../global/context/toast-context/ToastNotificationContext'

interface IRemoveTireRackOrderProps {
  handleClose: Function
  tireRackOrderNumber: string
}

export default function RemoveTireRackOrder(props: IRemoveTireRackOrderProps) {
  const { queryOrderData } = useContext(WoDetailContext)
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)
  const [isChecked, setIsChecked] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { id } = useParams()

  async function handleRemoveTireRackOrder() {
    try {
      setIsLoading(true)
      await fetchData(
        removeTireRackOrderFromOrder(id, props.tireRackOrderNumber),
      )
      await queryOrderData(id ?? '')
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: `TR Order ${props.tireRackOrderNumber} has been removed successfully!`,
        severity: 'success',
      })
      props.handleClose()
    } catch (err) {
      console.error(err)
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: `There was an error removing TR Order ${props.tireRackOrderNumber}.`,
        severity: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className={styles.inputsContainer}>
      <div className={styles.checkBoxContainer}>
        <Checkbox onChange={() => setIsChecked(!isChecked)} />
        <div>
          Are you sure you want to remove Tire Rack order{' '}
          {props.tireRackOrderNumber} from this order?
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <SecondaryButton
          buttonName='Cancel'
          onClick={() => props.handleClose()}
        />
        <PrimaryButton
          buttonName='Remove'
          disabled={!isChecked || isLoading}
          onClick={handleRemoveTireRackOrder}
        />
      </div>
    </div>
  )
}
